// Module
var code = "<div ng-controller=\"secureController as secureCtrl\"> <track-viewer></track-viewer> </div> ";
// Exports
module.exports = code;